import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Colors } from 'utils';
import device from './device';
import { cpLogo } from 'images';
import { createPortal } from 'react-dom';
import { lockPageScroll, unlockPageScroll } from './modalScrollLock';

const ModalWrapper = styled.div`
  .modal {
    &__wrapper {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: #000;
      opacity: 0.5;
      z-index: 100000;
      overflow-y: hidden;
      overflow-x: hidden;
    }
    &__content {
      box-sizing: border-box;
      overflow-x: hidden;
      border-radius: 12px;
      position: fixed;
      top: 50%;
      @media ${device.allMobile} {
        top: 50%;
      }
      left: ${(props) => (props.left ? props.left : '50%')};
      background: #fff;
      transform: translateX(-50%) translateY(-50%);
      z-index: 100001;
      width: ${(props) => (props.width ? props.width : '40%%')};
      @media ${device.allMobile} {
        width: calc(100vw - 24px);
        max-width: 448px;
        max-height: calc(100dvh - 24px);
      }
    }
    &__header {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 15px 15px 0;
    }
    &__header-top {
      position: relative;
      width: 100%;
      min-height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &__header-logo {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      img {
        height: 24.77px;
        width: auto;
        display: block;
      }
    }
    &__title {
      display: flex;
      align-items: center;
      p {
        margin: 0;
        font-size: 18px;
        font-weight: bold;
      }
      img {
        width: 30px;
        height: 30px;
        margin-right: 10px;
      }
    }
    &__close {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      padding: 0;
      button {
        border: none;
        background: none;
        font-size: 30px;
        font-weight: bold;
        color: ${Colors.secondaryColor};
        margin: 0;
      }
    }
    &__body {
      overflow-x: hidden;
      padding: 0 24px 24px;
      max-height: 80vh;
      overflow-y: auto;
      overscroll-behavior: contain;
      -webkit-overflow-scrolling: touch;
      @media ${device.allMobile} {
        overflow-x: hidden;
        max-height: calc(100dvh - 98px);
        overflow-y: auto;
        padding: 12px 12px 20px;
      }
    }
  }
`;

export default class Modal extends Component {
  componentDidMount() {
    if (this.props.showModal) {
      lockPageScroll();
      this.isScrollLocked = true;
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.showModal && this.props.showModal) {
      lockPageScroll();
      this.isScrollLocked = true;
    } else if (prevProps.showModal && !this.props.showModal) {
      unlockPageScroll();
      this.isScrollLocked = false;
    }
  }

  componentWillUnmount() {
    if (this.isScrollLocked) {
      unlockPageScroll();
    }
  }

  render() {
    const { image, title, children, showModal, handelCloseModal, left, width, noClose, leftMargin, noLogo, leftTitle } =
      this.props;

    if (!showModal) return null;

    return createPortal(
      <ModalWrapper width={width} left={left ?? '50%'}>
            <div
              className="modal__wrapper"
              onClick={() => {
                handelCloseModal();
              }}
            ></div>
            <div className="modal__content">
              <div className="modal__header">
                <div className="modal__header-top">
                  {leftTitle && leftTitle !== '' && (
                    <div style={{ position: 'absolute', left: 10, top: leftMargin ?? 60 }}>
                      {leftTitle}
                    </div>
                  )}
                  {!noLogo && (
                    <div className="modal__header-logo">
                      <img src={cpLogo} alt="commonsplace logo" />
                    </div>
                  )}
                  <div className="modal__close">
                    <button
                      onClick={() => {
                        handelCloseModal();
                      }}
                    >
                      &times;
                    </button>
                  </div>
                </div>

                {title !== '' && (
                  <div className="modal__title">
                    {image && <img src={image} alt={title} />}
                    <p>{title}</p>
                  </div>
                )}
              </div>

              <div className="modal__body">{children}</div>
            </div>
      </ModalWrapper>,
      document.body
    );
  }
}

Modal.propTypes = {
  children: PropTypes.object.isRequired,
  title: PropTypes.string,
  image: PropTypes.string,
  showModal: PropTypes.bool.isRequired,
  handelCloseModal: PropTypes.func.isRequired,
};
